import React, { CSSProperties } from 'react'
import { HeaderEstadual } from './HeaderEstadual'
import { LogoSection } from './LogoSection'
import { Navbar } from '../navigation'
import { useResponsive } from '../../hooks/useResponsive'
import { Chatbot } from './Chatbot'

interface LayoutProps {
  children: React.ReactNode
}

/**
 * Componente Layout principal da aplicação
 * 
 * Renderiza os componentes na ordem correta:
 * 1. HeaderEstadual (governo do estado) - fixo no topo
 * 2. LogoSection (logos e botão) - fixo abaixo do header
 * 3. Navbar (navegação) - fixo abaixo do logo
 * 4. Conteúdo das páginas (children)
 * 5. Footer (renderizado pelas páginas individualmente)
 * 
 * Reason: Usa paddingTop no main para empurrar o conteúdo abaixo dos elementos fixos
 */
export function Layout({ children }: LayoutProps) {
  const { totalFixedHeaderHeight } = useResponsive()

  // Estilo do container principal
  const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    width: '100%'
  }

  // Reason: O paddingTop compensa os elementos fixos (HeaderEstadual + LogoSection + Navbar)
  // O espaçamento extra no mobile já está incluído na altura do headerEstadual
  const contentStyle: CSSProperties = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: `${totalFixedHeaderHeight}px`
  }

  return (
    <div style={containerStyle}>
      {/* Componentes fixos do header - renderizados em ordem de z-index */}
      <HeaderEstadual />
      <LogoSection />
      <Navbar />

      <Chatbot />
      {/* Conteúdo das páginas - paddingTop compensa os elementos fixos */}
      <main style={contentStyle}>
        {children}
      </main>
    </div>
  )
}
